import gql from 'graphql-tag'

export const DeclarationFunctionFragment = gql`
  fragment DeclarationFunctionFragment on DeclarationFunction {
    id
    name
    description
    canDeclareNothing
    order
  }
`
